import React from "react";
import ReactDOM from "react-dom/client";
import { ConfigProvider } from "antd";
import locale from "@aligov/global-locale";
import zhCN from "antd/locale/zh_CN";
import enUS from "antd/locale/en_US";
import th_TH from "antd/locale/th_TH";

import App from "./App";
import "./i18n/config";
// import { useTranslation } from "react-i18next";

/**
 * axios全局配置
 * */
import "./axios.config";

const antdLocaleMap = {
  "zh-CN": zhCN,
  "en-US": enUS,
  "th-TH": th_TH,
};

// 默认语言为泰语：若浏览器未保存语言，写入 x-hng cookie=th-TH，确保后端请求携带默认语言
if (!locale.getLocale().lang) {
  locale.setLang("th-TH");
}

const AppWithLocale = () => {
  const { lang } = locale.getLocale();
  const localelng = antdLocaleMap[lang] || th_TH;

  return (
    <ConfigProvider locale={localelng}>
      <App />
    </ConfigProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("owtb-root"));

root.render(<AppWithLocale />);
